/* Aude Pluie — accordéon doux : <details class="ap-acc"> avec animation de hauteur + groupes "un seul ouvert" (data-acc-group).
   Robustesse : finalise via transitionend OU un timer de secours (si transitionend ne se déclenche pas). */
(function () {
  if (window.__apAccordion) return;
  window.__apAccordion = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var DUR = 300;

  function panel(d) {
    var p = d.querySelector('.ap-acc__panel');
    return (p && p.parentNode === d) ? p : null;
  }
  function cleanup(d, p) {
    if (p._apEnd) { p.removeEventListener('transitionend', p._apEnd); p._apEnd = null; }
    if (d._apT) { clearTimeout(d._apT); d._apT = null; }
  }
  function finish(d, p, toOpen) {
    cleanup(d, p);
    if (!toOpen) d.open = false;
    p.style.height = '';
    p.style.transition = '';
    d.dataset.apAnim = '';
  }
  function animate(d, p, toOpen) {
    if (reduce) { d.open = toOpen; d.dataset.apAnim = ''; return; }
    cleanup(d, p);
    if (toOpen) d.open = true;
    var h = p.scrollHeight;
    p.style.height = (toOpen ? 0 : h) + 'px';
    p.getBoundingClientRect();
    p.style.transition = 'height ' + DUR + 'ms ease';
    p.style.height = (toOpen ? h : 0) + 'px';
    p._apEnd = function () { finish(d, p, toOpen); };
    p.addEventListener('transitionend', p._apEnd);
    d._apT = setTimeout(function () { finish(d, p, toOpen); }, DUR + 90);
  }
  function bind(d) {
    if (d.dataset.apAccReady) return;
    var s = d.querySelector('summary'), p = panel(d);
    if (!s || !p) return;
    d.dataset.apAccReady = '1';
    s.addEventListener('click', function (e) {
      e.preventDefault();
      if (d.dataset.apAnim === '1') return;
      if (d.open) { d.dataset.apAnim = '1'; animate(d, p, false); return; }
      var group = d.closest('[data-acc-group]');
      if (group) {
        group.querySelectorAll('details.ap-acc[open]').forEach(function (o) {
          if (o !== d) {
            var op = panel(o);
            if (op) { o.dataset.apAnim = '1'; animate(o, op, false); } else { o.open = false; }
          }
        });
      }
      d.dataset.apAnim = '1'; animate(d, p, true);
    });
  }
  function init(root) {
    (root || document).querySelectorAll('details.ap-acc').forEach(bind);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
